// extracted by mini-css-extract-plugin
module.exports = {"clickable":"NavigationChip_clickable__qnraTbW4yLz2uoZlgOACZ"};